import { render, staticRenderFns } from "./upgradeModal.vue?vue&type=template&id=03ded79e&scoped=true&"
import script from "./upgradeModal.vue?vue&type=script&lang=js&"
export * from "./upgradeModal.vue?vue&type=script&lang=js&"
import style0 from "./upgradeModal.vue?vue&type=style&index=0&id=03ded79e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ded79e",
  null
  
)

export default component.exports